export default "__VITE_ASSET__BwWyUF4P__"